// extracted by mini-css-extract-plugin
module.exports = {"scrollableX":"_3UDn-lZEVNTPLKrgHfxtRc","scrollableY":"lWj2cBokAY-TpldLuIyCs","nonScrollable":"DiZt9EsVS6Stu-bs1uF9z"};